module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-5-m3.9a2522a7.jpg";